export default "__VITE_ASSET__r$ca4HVW__"